import React, { FunctionComponent } from 'react'
import PreSetRow from './Pre'
import LiveSetRow from './Live'
import PostSetRow from './Post'
import { SetProps } from './SetRowTypes'

const SetRow: FunctionComponent<SetProps> = props => {
    if (props.type === 'PRE') return <PreSetRow {...props} />
    if (props.type === 'LIVE') return <LiveSetRow {...props} />
    return <PostSetRow {...props} />
}

export default SetRow
